import React from "react";

import { Toolbar } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

import FavoriteButton from "../common/FavoriteButton";
import { Feedback } from "../common/Feedback";
import NavigateToTranslationButton from "../common/NavigateToTranslationButton";
import { Annotations } from "../unit/Annotations";

type Props = {
  resource?: Pick<Resource, "id" | "sk" | "workspaceId">;
  allowAnnotations?: boolean;
};

const ResourceTools = ({ resource, allowAnnotations }: Props) => {
  if (resource == null) return null;

  return (
    <Toolbar>
      <FavoriteButton item={resource} />
      <Feedback resource={resource} />
      <NavigateToTranslationButton resource={resource} />
      {allowAnnotations && <Annotations resource={resource} />}
    </Toolbar>
  );
};

export default ResourceTools;
